import { apiCreate } from './ApiBaseActions';
export const API_CREATE_PROFESSIONAL_INTRODUCTION = 'API_CREATE_PROFESSIONAL_INTRODUCTION';
export const apiCreateProfessionalIntroduction = (values, meta) => apiCreate(API_CREATE_PROFESSIONAL_INTRODUCTION, '/introduction/professional', values, meta || {});
